const SPACING = 4;

export const spacing = (factor: number) => SPACING * factor;
